const currentOrigin = window.location.origin;
const targetOrigin = currentOrigin.indexOf("localhost") !== -1 ? 'https://localhost:7280' : currentOrigin;
export const apiRootUrl = targetOrigin + '/api/v1';

export const mediaTypeList = [
    {
        color: "#007DFF",
        type: "image",
        typeJa: "画像",
        extentions: ["jpg", "jpeg", "png", "gif"],
    },
    {
        color: "#00A152",
        type: "video",
        typeJa: "動画",
        extentions: ["mp4"],
    }
];